import { useRequesterStore } from '../stores/requester'
let requesterX: any

export async function uploadInvoices(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/purchase/upload`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function getAllPurchases(otherEgresos = false) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/purchase/get-all?otherEgresos=${otherEgresos}`,
      withAuth: true,
    })
    return resp
  } catch (e) {
    throw e
  }
}
export async function getPurchaseDetail(id: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/purchase/${id}`,
      withAuth: true,
    })
    return resp
  } catch (e) {
    throw e
  }
}

export async function deletePurchase(id: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Delete({
      route: `/purchase/delete/${id}`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function setDeductibleProduct(body: { detail?: string; cleanDetail?: string; deductible: boolean }) {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Put({
    route: '/purchase/deductible-product',
    withAuth: true,
    body,
  })
}

export async function updateInvoice(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Put({
      route: `/purchase/update`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function reconcileSriReceived(files: { name: string; content: string }[]) {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Post({
    route: `/purchase/reconcile-sri`,
    withAuth: true,
    body: { files },
  })
}
